module.exports = __webpack_public_path__ + "img/eb89d0c.jpg";